import { html, css } from 'lit-element';
import './soccer-season-auth-detail.js';
import { SPLeagueDetail } from './sp-league-detail.js';
class SoccerLeagueDetail extends SPLeagueDetail {
    constructor() {
        super();
    }

    static get styles() {
        return [super.styles, css``];
    }

    static get properties() {
        return {
            seasonAuths: {
                type: Object,
            },
        };
    }

    render() {
        if (this.isViewMode) {
            return html`<div class="detail-header">${this.renderDisplayHeader()}</div>
                <div class="content">${this.renderDisplaySelectedSeasons()}</div>
                <div class="content">${this.renderSeasonAuths()}</div>`;
        }
        return html`
            <div class="detail-header">${this.renderEditHeader()}</div>
            <div class="content">${this.renderEditSelectedSeasons()}</div>
            <div class="content">${this.renderSeasonAuths()}</div>
        `;
    }

    renderSeasonAuths() {
        const { isViewMode, leagueId, seasonAuths } = this;
        const allowedSeasons = this.getAllowedSeasons();
        return html`<soccer-season-auth-detail
            .isViewMode=${isViewMode}
            .leagueId=${leagueId}
            .seasonAuths=${seasonAuths}
            .seasons=${allowedSeasons}></soccer-season-auth-detail>`;
    }
}

window.customElements.define('soccer-league-detail', SoccerLeagueDetail);
